import { render, staticRenderFns } from "./CartoesPdf.vue?vue&type=template&id=31c8dc48"
import script from "./CartoesPdf.vue?vue&type=script&lang=js"
export * from "./CartoesPdf.vue?vue&type=script&lang=js"
import style0 from "./CartoesPdf.vue?vue&type=style&index=0&id=31c8dc48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports